import React from 'react'
import FAQsContent from '../Components/FAQs/FAQsContent';
import LoginLayout from '../Layouts/LoginLayout';

export default function FAQs() {
  return (
    <LoginLayout>
        <FAQsContent />
    </LoginLayout>
  )
}
